require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-ross-buchanan.json") })
        }
      }, "path---blog-author-ross-buchanan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-ross-buchanan!./.cache/json/blog-author-ross-buchanan.json
// module id = 702
// module chunks = 231608221292675